export const CONTROLS_WRAPPER_HEIGHT = 80
